import { render, staticRenderFns } from "./VuesticNavbar.vue?vue&type=template&id=f21b6560"
import script from "./VuesticNavbar.vue?vue&type=script&lang=js"
export * from "./VuesticNavbar.vue?vue&type=script&lang=js"
import style0 from "./VuesticNavbar.vue?vue&type=style&index=0&id=f21b6560&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f21b6560')) {
      api.createRecord('f21b6560', component.options)
    } else {
      api.reload('f21b6560', component.options)
    }
    module.hot.accept("./VuesticNavbar.vue?vue&type=template&id=f21b6560", function () {
      api.rerender('f21b6560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar.vue"
export default component.exports